import { sortDates } from "../sortDates";
import { getBookingDate } from "../getBookingDate";

export const formatLeadTimeChartData = (
  bookedBookings,
  cancelledBookings,
  dataMode
) => {
  const bookedTotalsByDate = bookedBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalLeadTime: 0, bookingCount: 0 };
    const createdAt = new Date(booking.createdAt);
    createdAt.setUTCHours(0, 0, 0, 0);
    const fromdateParts = booking.fromdate.split("-");
    const [day, month, year] = fromdateParts.map(Number);
    const fromDate = new Date(Date.UTC(year, month - 1, day));
    const leadTime = (fromDate - createdAt) / (1000 * 60 * 60 * 24);
    if (leadTime >= 0) {
      acc[date].totalLeadTime += leadTime;
      acc[date].bookingCount += 1;
    }
    return acc;
  }, {});
  const cancelledTotalsByDate = cancelledBookings.reduce((acc, booking) => {
    const date = getBookingDate(booking, dataMode);
    if (!acc[date]) acc[date] = { totalLeadTime: 0, bookingCount: 0 };
    const createdAt = new Date(booking.createdAt);
    createdAt.setUTCHours(0, 0, 0, 0);
    const fromdateParts = booking.fromdate.split("-");
    const [day, month, year] = fromdateParts.map(Number);
    const fromDate = new Date(Date.UTC(year, month - 1, day));
    const leadTime = (fromDate - createdAt) / (1000 * 60 * 60 * 24);
    if (leadTime >= 0) {
      acc[date].totalLeadTime += leadTime;
      acc[date].bookingCount += 1;
    }
    return acc;
  }, {});

  const labels = sortDates([
    ...new Set([
      ...Object.keys(bookedTotalsByDate),
      ...Object.keys(cancelledTotalsByDate),
    ]),
  ]);
  const bookedData = labels.map((date) => {
    const { totalLeadTime, bookingCount } = bookedTotalsByDate[date] || {
      totalLeadTime: 0,
      bookingCount: 0,
    };
    return bookingCount > 0
      ? Number((totalLeadTime / bookingCount).toFixed(2))
      : 0;
  });
  const cancelledData = labels.map((date) => {
    const { totalLeadTime, bookingCount } = cancelledTotalsByDate[date] || {
      totalLeadTime: 0,
      bookingCount: 0,
    };
    return bookingCount > 0
      ? Number((totalLeadTime / bookingCount).toFixed(2))
      : 0;
  });

  return {
    labels,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(75, 192, 75, 0.6)",
        borderColor: "rgba(75, 192, 75, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
};
